

















import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class Header extends Vue {
  private openSideBar(): void {
    this.$emit("openSideBar");
  }

  private goToOption(url: string): void {
    this.$router.currentRoute.path !== url ? this.$router.push(url) : false;
  }
}
